const horizontalPos = {
  start: 'left',
  end: 'right',
  left: 'left',
  middle: 'middle',
  right: 'right',
};

export function validatePosition(pos) {
  const parts = pos.split(' ');

  if (parts.length !== 2) return false;

  const vertical = ['top', 'center', 'bottom'];
  const horizontal = ['left', 'middle', 'right', 'start', 'end'];

  return vertical.includes(parts[0]) && horizontal.includes(parts[1]);
}

export function parsePosition(pos) {
  const parts = pos.split(' ');
  return {
    vertical: parts[0],
    horizontal: horizontalPos[parts[1]],
  };
}

export function getAnchorProps(el, offsetHorizontal = 0, offsetVertical = 0) {
  let { top, left, right, bottom, width, height } = el.getBoundingClientRect();

  top -= offsetVertical;
  left -= offsetHorizontal;
  bottom += offsetVertical;
  right += offsetHorizontal;

  width += offsetHorizontal;
  height += offsetVertical;

  return {
    top,
    left,
    right,
    bottom,
    width,
    height,
    middle: left + (right - left) / 2,
    center: top + (bottom - top) / 2,
  };
}

export function getTargetProps(el) {
  return {
    top: 0,
    center: el.offsetHeight / 2,
    bottom: el.offsetHeight,
    left: 0,
    middle: el.offsetWidth / 2,
    right: el.offsetWidth,
  };
}

export function setPosition({
  el, anchorEl,
  anchorOrigin, selfOrigin,
  offsetHorizontal, offsetVertical,
  fit,
  maxHeight, maxWidth,
}) {
  const anchorProps = getAnchorProps(
    anchorEl,
    offsetHorizontal,
    offsetVertical,
  );

  let elStyle = {
    maxHeight,
    maxWidth,
    visibility: 'visible',
  };

  if (fit === true) {
    elStyle.minWidth = `${anchorProps.width}px`;
  }

  Object.assign(el.style, elStyle);

  const targetProps = getTargetProps(el);
  const props = {
    top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
    left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal],
  };

  applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin);

  elStyle = {
    top: `${props.top}px`,
    left: `${props.left}px`,
  };

  if (props.maxHeight) {
    elStyle.maxHeight = `${props.maxHeight}px`;

    if (anchorProps.height > props.maxHeight) {
      elStyle.minHeight = elStyle.maxHeight;
    }
  }
  if (props.maxWidth) {
    elStyle.maxWidth = `${props.maxWidth}px`;

    if (anchorProps.width > props.maxWidth) {
      elStyle.minWidth = elStyle.maxWidth;
    }
  }

  Object.assign(el.style, elStyle);
}

export function applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin) {
  const currentHeight = targetProps.bottom;
  const currentWidth = targetProps.right;
  const innerHeight = window.innerHeight;
  const innerWidth = document.body.clientWidth;

  if (props.top < 0 || props.top + currentHeight > innerHeight) {
    if (selfOrigin.vertical === 'center') {
      props.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2
        ? Math.max(0, innerHeight - currentHeight)
        : 0;
      props.maxHeight = Math.min(currentHeight, innerHeight);
    } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(
        innerHeight,
        anchorOrigin.vertical === 'center'
          ? anchorProps.center
          : (anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top),
      );
      props.maxHeight = Math.min(currentHeight, anchorY);
      props.top = Math.max(0, anchorY - currentHeight);
    } else {
      props.top = Math.max(0, anchorOrigin.vertical === 'center'
        ? anchorProps.center
        : (anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom),
      );
      props.maxHeight = Math.min(currentHeight, innerHeight - props.top);
    }
  }

  if (props.left < 0 || props.left + currentWidth > innerWidth) {
    props.maxWidth = Math.min(currentWidth, innerWidth);
    if (selfOrigin.horizontal === 'middle') {
      props.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2
        ? Math.max(0, innerWidth - currentWidth)
        : 0;
    } else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
      const anchorX = Math.min(
        innerWidth,
        anchorOrigin.horizontal === 'middle'
          ? anchorProps.middle
          : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left),
      );
      props.maxWidth = Math.min(currentWidth, anchorX);
      props.left = Math.max(0, anchorX - props.maxWidth);
    } else {
      props.left = Math.max(0, anchorOrigin.horizontal === 'middle'
        ? anchorProps.middle
        : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right),
      );
      props.maxWidth = Math.min(currentWidth, innerWidth - props.left);
    }
  }
}
